import React from 'react';
import PropTypes from 'prop-types';
import './LabCard.scss';

const LabCard = ({ labDetails, isSelected, selectLab }) => {
  const selectLabID = () => {
    selectLab(labDetails.item_id);
  };

  const calculateTotalMRP = () => {
    const { price_breakup } = labDetails;
    let sp = 0;
    let mrp = 0;
    price_breakup.forEach(item => {
      sp = sp + Number(item.pe_selling_price);
      mrp = mrp + Number(item.mrp);
    });
    return (
      <div className="textSubtitl">
        <span className="pePrice">&#8377; {sp}</span>
        <span className="mrPrice">&#8377; {mrp}</span>
        <span className="savings">save {Math.round(((mrp - sp) / mrp) * 100)}%</span>
      </div>
    );
  };

  return (
    <div className="mainContainr">
      <div className="imgContainr">
        <img src={labDetails.item_logo} alt="x" />
      </div>
      <div className="textContainer">
        <div className="textTitle">{labDetails.item_name}</div>
        {labDetails.price_breakup ? calculateTotalMRP() :
        <div className="textSubtitl">
          <span className="pePrice">&#8377; {labDetails.pe_selling_price}</span>
          <span className="mrPrice">&#8377; {labDetails.mrp}</span>
          <span className="savings">save {labDetails.discount_percent}%</span>
        </div>
        }
        {labDetails.price_breakup && <div className="">
          {labDetails.price_breakup.map(item => (
            <div className="availableTest">{item.item_name} ({item.item_type}) is available - &#8377;{item.pe_selling_price}</div>
            ))}
        </div>}
        {labDetails.certifications && <div className="textSubtitl extraPad">
          <img src={require('../../images/labCertificate.svg')} alt="x" />{labDetails.certifications}
        </div>}
        {labDetails.neighbourhood && <div className="textSubtitl">
          <img src={require('../../images/location.svg')} alt="x" />{labDetails.neighbourhood}
        </div>}
      </div>
      <div className="selectContainer">
        <input checked={isSelected} type="radio" name="refill" value={2} onClick={selectLabID} />
      </div>
    </div>
  );
};

LabCard.propTypes = {
  labDetails: PropTypes.object.isRequired,
  selectLab: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default LabCard;
